import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Tooltip from '@material-ui/core/Tooltip';

import Checkbox from '../../shared/Checkbox';
import AddButton from '../../shared/AddButton';

import {
  caseStatusOptions,
  setAllocationStatuses,
  procedureEquipmentListItemTypes,
  kitItemTypes,
} from '../../../constants/enums';

import ParentKitIcon from '../../../assets/icons/ParentKitIcon';
import KitIcon from '../../../assets/icons/KitIcon';

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: '12px',
    padding: '4px 8px',
    borderRadius: 8,
  },
}));

const ProcedureEquipmentList = (props) => {
  const {
    procedureEquipmentList,
    kitsList = [],
    itemsList = [],
    selectedKits = [],
    selectedItems = [],
    status,
    noKitsChecked,
    onChangeKits,
    onChangeItems,
    search,
  } = props;

  const classes = useStyles();

  const getChildrenNames = (children) => {
    if (!children?.length) {
      return '';
    }
    return children?.map((item) => {
      const arr = item?.type === kitItemTypes.KIT.value ? kitsList : itemsList;
      const kitItem = arr?.find((i) => i.id === item.id);
      return kitItem?.code || kitItem?.name || '';
    }).join(', ');
  };

  const getItemTooltip = (quantity, min, max, fixed) => {
    if (fixed) {
      return 'Fixed QTY';
    }
    if (min && quantity <= min) {
      return 'Minimum QTY';
    }
    if (max && quantity >= max) {
      return 'Maximum QTY';
    }
    return '';
  };

  return (
    <div className="">
      <div className="m-t-lg d-flex font-bold font-size-bg m-b-md">
        <KitIcon />
        <span className="m-l-sm">
          {procedureEquipmentList?.name || 'Equipment List'}
        </span>
      </div>

      {!!procedureEquipmentList?.description && (
        <div className='p-t-md p-b-md'>
          {procedureEquipmentList.description}
        </div>
      )}

      <div>
        {procedureEquipmentList?.items?.map((equipmentItem) => {
          if (equipmentItem.type === procedureEquipmentListItemTypes.TITLE.value) {
            return (
              <div>
                <div className="font-bold m-t-md">{equipmentItem.title}</div>
                <div className="m-t-sm m-b-sm">{equipmentItem.subtitle}</div>
              </div>
            );
          }

          if (equipmentItem.type === procedureEquipmentListItemTypes.KIT.value) {
            const kit = kitsList.find((k) => k.id === equipmentItem.value);
            const updatedKit = selectedKits.find((k) => k.id === equipmentItem.value);
            if (kit && (!search || kit?.name?.toLowerCase().includes(search?.toLowerCase()) || kit?.kitId?.toLowerCase().includes(search?.toLowerCase()))) {
              return (
                <div className="md-user-info" key={equipmentItem.value}>
                  <Checkbox
                    disabled={noKitsChecked || (!!equipmentItem.preSelect && !!equipmentItem.mandatory) || (
                      status && (status === caseStatusOptions.completed || status === caseStatusOptions.overdue) && (
                        updatedKit?.status !== setAllocationStatuses.AVAILABLE.value || !updatedKit
                      )
                    )}
                    required={!!equipmentItem.mandatory}
                    input={{
                      checked: !!selectedKits.find((k) => k.id === equipmentItem.value),
                      onChange: (e) => {
                        if (e.target.checked) {
                          onChangeKits([
                            ...selectedKits,
                            {
                              id: equipmentItem.value,
                              quantity: updatedKit && updatedKit.quantity ? updatedKit.quantity : (equipmentItem?.quantity || 1),
                            },
                          ]);
                        } else {
                          if (updatedKit.status && updatedKit.status !== setAllocationStatuses.AVAILABLE.value) {
                            return;
                          }
                          onChangeKits(selectedKits.filter((k) => k.id !== equipmentItem.value));
                        }
                      },
                    }}
                    fontSize="small"
                    label={kit.name}
                    fontWeight="regular"
                  />

                  {!!selectedKits.find((k) => k.id === equipmentItem.value) && kit.allowQuantity && (
                    <Tooltip
                      title={getItemTooltip(updatedKit.quantity, equipmentItem.min, equipmentItem.max, equipmentItem.fixedQuantity)}
                      aria-label="required-checkbox"
                      classes={{ tooltip: classes.tooltip }}
                    >
                      <div className="d-flex">
                        <AddButton
                          width={24}
                          height={24}
                          variant="remove"
                          disabled={(updatedKit?.status && updatedKit?.status !== setAllocationStatuses.AVAILABLE.value) || !!equipmentItem.fixedQuantity || (equipmentItem.min && updatedKit.quantity <= equipmentItem.min)}
                          onClick={() => {
                            const kits = [...selectedKits];
                            const updatedKit = kits.find((k) => k.id === equipmentItem.value);
                            if (updatedKit && updatedKit.quantity > 1) {
                              updatedKit.quantity = updatedKit.quantity - 1;
                              onChangeKits(kits);
                            }
                          }}
                        />
                        <div
                          style={{ width: 16 }}
                          className="m-l-md m-r-md text-center"
                        >
                          {selectedKits?.find((k) => k.id === equipmentItem.value)?.quantity || 1}
                        </div>
                        <AddButton
                          width={24}
                          height={24}
                          disabled={(updatedKit?.status && updatedKit?.status !== setAllocationStatuses.AVAILABLE.value) || !!equipmentItem.fixedQuantity || (equipmentItem.max && updatedKit.quantity >= equipmentItem.max)}
                          onClick={() => {
                            const kits = [...selectedKits];
                            const updatedKit = kits.find((k) => k.id === equipmentItem.value);
                            updatedKit.quantity = updatedKit && updatedKit.quantity ? updatedKit.quantity + 1 : 2;
                            onChangeKits(kits);
                          }}
                        />
                      </div>
                    </Tooltip>
                  )}

                  {!!kit.isParent && <div className="m-l-md">
                    <Tooltip
                      title={getChildrenNames(kit.children)}
                      aria-label="parent-kit-icon"
                      classes={{ tooltip: classes.tooltip }}
                    >
                      <div>
                        <ParentKitIcon />
                      </div>
                    </Tooltip>
                  </div>}
                </div>
              );
            }
            return null;
          }

          if (equipmentItem.type === procedureEquipmentListItemTypes.ITEM.value) {
            const item = itemsList.find((i) => i.id === equipmentItem.value);
            const updatedItem = selectedItems.find((i) => i.id === equipmentItem.value);
            if (item && (!search || item?.code?.toLowerCase().includes(search?.toLowerCase()) || item?.description?.toLowerCase().includes(search?.toLowerCase()))) {
              return (
                <div className="md-user-info" key={equipmentItem.value}>
                  <Checkbox
                    required={!!equipmentItem.mandatory}
                    disabled={noKitsChecked || (!!equipmentItem.preSelect && !!equipmentItem.mandatory) || (
                      status && (status === caseStatusOptions.completed || status === caseStatusOptions.overdue) && (
                        updatedItem?.status !== setAllocationStatuses.AVAILABLE.value || !updatedItem
                      )
                    )}
                    input={{
                      checked: !!selectedItems.find((i) => i.id === equipmentItem.value),
                      onChange: (e) => {
                        if (e.target.checked) {
                          onChangeItems([
                            ...selectedItems,
                            { id: item.id, quantity: equipmentItem?.quantity || 1 },
                          ]);
                        } else {
                          if (updatedItem.status && updatedItem.status !== setAllocationStatuses.AVAILABLE.value) {
                            return;
                          }
                          onChangeItems(selectedItems?.filter((i) => i.id !== item.id));
                        }
                      },
                    }}
                    fontSize="small"
                    label={`${item.checklistDescription || item.description} – ${item.code}`}
                    fontWeight="regular"
                  />

                  {!!selectedItems.find((i) => i.id === equipmentItem.value) && (
                    <Tooltip
                      title={getItemTooltip(updatedItem.quantity, equipmentItem.min, equipmentItem.max, equipmentItem.fixedQuantity)}
                      aria-label="required-checkbox"
                      classes={{ tooltip: classes.tooltip }}
                    >
                      <div className="d-flex">
                        <AddButton
                          width={24}
                          height={24}
                          variant="remove"
                          disabled={(updatedItem?.status && updatedItem?.status !== setAllocationStatuses.AVAILABLE.value) || !!equipmentItem.fixedQuantity || (equipmentItem.min && updatedItem.quantity <= equipmentItem.min)}
                          onClick={() => {
                            const items = [...selectedItems];
                            const updatedItem = items.find((k) => k.id === equipmentItem.value);
                            if (updatedItem && updatedItem.quantity > 1) {
                              updatedItem.quantity = updatedItem.quantity - 1;
                              onChangeItems(items);
                            }
                          }}
                        />
                        <div
                          style={{ width: 16 }}
                          className="m-l-md m-r-md text-center"
                        >
                          {selectedItems?.find((i) => i.id === equipmentItem.value)?.quantity || 1}
                        </div>
                        <AddButton
                          width={24}
                          height={24}
                          disabled={(updatedItem?.status && updatedItem?.status !== setAllocationStatuses.AVAILABLE.value) || !!equipmentItem.fixedQuantity || (equipmentItem.max && updatedItem.quantity >= equipmentItem.max)}
                          onClick={() => {
                            const items = [...selectedItems];
                            const updatedItem = items.find((i) => i.id === equipmentItem.value);
                            updatedItem.quantity = updatedItem && updatedItem.quantity ? updatedItem.quantity + 1 : 2;
                            onChangeItems(items);
                          }}
                        />
                      </div>
                    </Tooltip>
                  )}
                </div>
              );
            }
            return null;
          }

          return null;
        })}
      </div>
    </div>
  );
};

export default ProcedureEquipmentList;